import { useQuery } from '@apollo/client';
import { CITRIN_GET_CURRENCY_RATES, GetCurrencyRatesResponse } from '..';

export const useGetCurrencyRatesQuery = () => {
    const { data, previousData, ...rest } = useQuery<GetCurrencyRatesResponse>(CITRIN_GET_CURRENCY_RATES, {
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'cache-first',
    });

    return {
        ...rest,
        previousData: previousData?.CITRIN_MGT_getCurrencyRates,
        data: data?.CITRIN_MGT_getCurrencyRates ?? [],
    };
};
